import {useContext, useEffect, useState} from "react";
import {useNavigate, useParams, useLocation} from "react-router-dom";
import "./style.css";
import {CadastroContext} from "../../../../contexts/CadastroContext";
import AlertMessage from "../../../Alert";
import {Load} from "../../../Load";
import {Card, Button, Form} from "react-bootstrap";
import InputMask from "react-input-mask";
import api from "../../../../services/api";
import {session, StorageKeys} from "../../../../services/storage.service";
import {AsoInformation} from "../../../../types/aso-information";

const AsoValidarInfoTrabalhadorExistente = () => {
    const navigate = useNavigate();
    const [isDisabled, setIsDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [nomeEditado, setNomeEditado] = useState(false);
    const [cpfEditado, setCpfEditado] = useState(false);
    const [sexoEditado, setSexoEditado] = useState(false);
    const [dataNascimentoEditado, setDataNascimentoEditado] = useState(false);

    const [nome, setNome] = useState("");
    const [cpf, setCpf] = useState("");
    const [cpfMascaradoBackend, setCpfMascaradoBackend] = useState(true);
    const [sexo, setSexo] = useState("");
    const [dataNascimento, setDataNascimento] = useState("");

    const [alert, setAlert] = useState({
        show: false,
        message: "",
        variant: "success",
    });


    const validarCPF = (value: string): boolean => {
        // Remove caracteres não numéricos
        const cpfDigitos = value.replace(/\D/g, "");

        // Verifica se o CPF possui 11 dígitos numéricos
        if (cpfDigitos.length !== 11) {
            return false;
        }

        // Verifica se todos os dígitos são iguais (CPF inválido)
        if (/^(\d)\1{10}$/.test(cpfDigitos)) {
            return false;
        }

        // Calcula o primeiro dígito verificador
        let soma = 0;
        for (let i = 0; i < 9; i++) {
            soma += parseInt(cpfDigitos.charAt(i)) * (10 - i);
        }
        let resto = soma % 11;
        let digitoVerificador1 = resto < 2 ? 0 : 11 - resto;

        // Verifica o primeiro dígito verificador
        if (parseInt(cpfDigitos.charAt(9)) !== digitoVerificador1) {
            return false;
        }

        // Calcula o segundo dígito verificador
        soma = 0;
        for (let i = 0; i < 10; i++) {
            soma += parseInt(cpfDigitos.charAt(i)) * (11 - i);
        }
        resto = soma % 11;
        let digitoVerificador2 = resto < 2 ? 0 : 11 - resto;

        // Verifica o segundo dígito verificador
        if (parseInt(cpfDigitos.charAt(10)) !== digitoVerificador2) {
            return false;
        }

        // CPF válido
        return true;
    };
    const todosEditados = nomeEditado && cpfEditado && sexoEditado && dataNascimentoEditado;
    const algumEditado = nomeEditado || cpfEditado || sexoEditado || dataNascimentoEditado;
    const cpfValido = validarCPF(cpf);
    const todosValidos = nome.trim() !== "" && cpfValido && sexo !== "" && dataNascimento !== "";
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);

    const asoInformation = session.get<AsoInformation>(
        StorageKeys.ASO_INFORMATION,
    )!;

    useEffect(() => {
        const fetchDadoMascaradoTrabalhador = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(
                    `dados-mascarado-trabalhador/${asoInformation.email}`,
                );

                if (response.data) {
                    const dados = response.data;
                    setNome(dados.nome || "");
                    setCpf(dados.cpf || "");
                    setSexo(dados.sexo || "");

                    if (dados.data_nascimento) {
                        const dataFormatada = new Date(dados.data_nascimento)
                            .toISOString()
                            .split("T")[0];
                        setDataNascimento(dataFormatada);
                    }

                    cadastro.userId = dados.id_usuario;
                    handleCadastroChange(cadastro)
                }
            } catch (error) {
                console.error(error);
                setAlert({
                    show: true,
                    message: "Erro ao buscar informações do trabalhador",
                    variant: "danger",
                });
            } finally {
                setIsLoading(false);
            }
        };

        void fetchDadoMascaradoTrabalhador();
    }, []);

    const handleCpfChange = (event: any) => {
        const value = event.target.value;
        setCpf(value);
        setCpfMascaradoBackend(false);
        setCpfEditado(true);
    };

    const handleCpfBlur = () => {
        const digits = cpf.replace(/\D/g, "");
        if (digits.length < 11 || !validarCPF(cpf)) {
            setAlert({
                show: true,
                message: "Insira um CPF válido!",
                variant: "danger",
            });
        } else {
            setAlert({...alert, show: false});
        }
    };

    const handleContinuar = async () => {
        if (!isDisabled && todosEditados && todosValidos) {
            cadastro.nome = nome;
            cadastro.cpf = cpf;
            cadastro.cpfValidado = true;
            cadastro.sexo = sexo;
            cadastro.data_nascimento = new Date(dataNascimento)
                .toISOString()
                .split("T")[0];
            handleCadastroChange(cadastro);

            await api.post("atualizar-cadastro-usuario-trabalhador", {
                id_usuario: cadastro.userId,
                nome,
                cpf,
                sexo,
                data_nascimento: cadastro.data_nascimento,
            });
        }

        return navigate(`/aso/registro/validar-identidade-aso/${asoInformation.dbName}`);
    };

    return (
        <>
            <Load isLoading={isLoading}/>
            {!isLoading && (
                <div className="aso-container-nome">
                    <div className="aso-container-card-nome">
                        <Card className="aso-card-nome">
                            <Card.Title
                                style={{
                                    textAlign: "center",
                                    padding: "15px",
                                    fontSize: "22px",
                                    fontWeight: "600",
                                    marginBottom: "0",
                                }}
                            >
                                Bem vindo de volta!
                            </Card.Title>
                            <Card.Text style={{
                                textAlign: "justify",
                                padding: "15px",
                                fontSize: "14px",
                                marginBottom: "0",
                            }}>
                                Precisamos validar algumas informações para garantir a segurança e a precisão dos
                                dados. <br/>
                                Por favor, valide seus dados e se preciso, clique no botão para edita-los antes de
                                continuar.
                            </Card.Text>
                            <div className="aso-card-content-container-nome">
                                {/* Editar informações */}
                                <Form.Check
                                    type="switch"
                                    id="editar-info-switch"
                                    label={`Deseja editar suas informações? ${!isDisabled ? "Sim" : "Não"}`}
                                    checked={!isDisabled}
                                    onChange={() => {
                                        setIsDisabled((prev) => {
                                            const novoValor = !prev;
                                            // Se estiver habilitando a edição, limpa os campos
                                            if (!novoValor) {
                                                setNome("");
                                                setCpf("");
                                                setCpfMascaradoBackend(false);
                                                setSexo("");
                                                setDataNascimento("");
                                                setNomeEditado(false);
                                                setCpfEditado(false);
                                                setSexoEditado(false);
                                                setDataNascimentoEditado(false);
                                            }
                                            return novoValor;
                                        });
                                    }}
                                />

                                {/* Mensagem de aviso ou confirmação */}
                                {!isDisabled && (
                                    <div className={`aso-edit-message ${todosEditados && todosValidos ? 'success' : 'warning'}`}>
                                        {todosEditados && todosValidos ? (
                                            <>
                                                <span className="aso-edit-message-icon">✓</span>
                                                <span>Todos os campos foram preenchidos corretamente!</span>
                                            </>
                                        ) : (
                                            <>
                                                <span className="aso-edit-message-icon">⚠</span>
                                                <span>
                                                    Para atualizar o cadastro, todos os campos precisam ser editados:
                                                    <ul className="aso-edit-message-list">
                                                        <li className={nomeEditado && nome.trim() !== "" ? "completed" : ""}>
                                                            Nome {nomeEditado && nome.trim() !== "" && "✓"}
                                                        </li>
                                                        <li className={cpfEditado && cpfValido ? "completed" : ""}>
                                                            CPF {cpfEditado && cpfValido && "✓"}
                                                        </li>
                                                        <li className={sexoEditado && sexo !== "" ? "completed" : ""}>
                                                            Sexo {sexoEditado && sexo !== "" && "✓"}
                                                        </li>
                                                        <li className={dataNascimentoEditado && dataNascimento !== "" ? "completed" : ""}>
                                                            Data de Nascimento {dataNascimentoEditado && dataNascimento !== "" && "✓"}
                                                        </li>
                                                    </ul>
                                                </span>
                                            </>
                                        )}
                                    </div>
                                )}
                                {/* Nome */}
                                <div className="aso-card-content-nome">
                                    <label htmlFor="nome-input" className="label-container">
                                        <span className="aso-card-content-nome-label-span">Nome</span>
                                    </label>
                                    <div className="aso-card-content-container-nome-input">
                                        <input
                                            type="text"
                                            placeholder="Digite seu nome completo"
                                            disabled={isDisabled}
                                            value={nome}
                                            onChange={(e) => {
                                                setNome(e.target.value);
                                                setNomeEditado(true);
                                            }}
                                            className="aso-card-content-nome-input"
                                        />
                                    </div>
                                </div>

                                {/* CPF */}
                                <div className="aso-card-content-nome">
                                    <label htmlFor="cpf-input" className="label-container">
                                        <span className="aso-card-content-nome-label-span">CPF</span>
                                    </label>
                                    <div className="aso-card-content-container-nome-input">
                                        {cpfMascaradoBackend && isDisabled ? (
                                            <input
                                                type="text"
                                                id="cpf-input"
                                                disabled={true}
                                                value={cpf}
                                                className="aso-card-content-nome-input"
                                                readOnly
                                            />
                                        ) : (
                                            <InputMask
                                                mask="999.999.999-99"
                                                type="text"
                                                pattern="[0-9]*"
                                                id="cpf-input"
                                                title="Digite um CPF numérico"
                                                minLength={11}
                                                disabled={isDisabled}
                                                value={cpfMascaradoBackend ? "" : cpf}
                                                className="aso-card-content-nome-input"
                                                placeholder="Digite um CPF númerico"
                                                onChange={handleCpfChange}
                                                onBlur={handleCpfBlur}
                                                onFocus={() => {
                                                    if (cpfMascaradoBackend) {
                                                        setCpf("");
                                                        setCpfMascaradoBackend(false);
                                                    }
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>

                                {/* Sexo */}
                                <div className="aso-card-content-nome">
                                    <label htmlFor="sexo-select" className="label-container">
                                        <span className="aso-card-content-nome-label-span">Sexo</span>
                                    </label>
                                    <div className="aso-card-content-container-nome-input">
                                        <select
                                            id="sexo-select"
                                            className="aso-card-content-nome-input"
                                            disabled={isDisabled}
                                            value={sexo}
                                            onChange={(e) => {
                                                setSexo(e.target.value);
                                                setSexoEditado(true);
                                            }}
                                        >
                                            <option value="">Selecione</option>
                                            <option value="M">Masculino</option>
                                            <option value="F">Feminino</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Data de Nascimento */}
                                <div className="aso-card-content-nome">
                                    <label
                                        htmlFor="data-nascimento-input"
                                        className="label-container"
                                    >
									<span className="aso-card-content-nome-label-span">
										Data de Nascimento
									</span>
                                    </label>
                                    <div className="aso-card-content-container-nome-input">
                                        <input
                                            type="date"
                                            disabled={isDisabled}
                                            value={dataNascimento}
                                            onChange={(e) => {
                                                setDataNascimento(e.target.value);
                                                setDataNascimentoEditado(true);
                                            }}
                                            className="aso-card-content-nome-input"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Card>
                        <div className="aso-button-nome-container">
                            <Button
                                variant="primary"
                                className="aso-button-nome-content"
                                onClick={async() => await handleContinuar()}
                                disabled={!isDisabled && algumEditado && (!todosEditados || !todosValidos)}
                            >
                                Continuar
                            </Button>
                        </div>
                    </div>
                </div>
            )}

            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({...alert, show: false})}
            />
        </>
    )
};

export default AsoValidarInfoTrabalhadorExistente;
